var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('music',{attrs:{"loading":_vm.loading,"page-data":_vm.pageData,"tracks":_vm.tracks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }